import React, { useState, useEffect } from "react"
import { Button, Input, Label } from "reactstrap"
import { UpdateINSCOMPANYStart } from "store/SuperAdmin/Lob-SubLob-company-income/InsuranceAction"
import { useDispatch, useSelector } from "react-redux"

const CreateIns = ({ updateData }) => {
  
  const dispatch = useDispatch()
  const [data, setData] = useState({
    id: "",
    insurancetype_id: "",
    name: "",
    color_code: "",
  })

  const handleChange = e => {
    const { name, value } = e.target
    setData(prev => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleSubmit = e => {
    e.preventDefault()
    dispatch(UpdateINSCOMPANYStart(data))
  }

  useEffect(() => {
    if (updateData && updateData.length > 0) {
      const Lobs = updateData[0]
      setData({
        id: Lobs.id || "",
        insurancetype_id: Lobs.ins_id || "",
        name: Lobs.name || "",
        color_code: Lobs.color_code || "",
      })
    }
  }, [updateData])

  return (
    <>
      <Label>Insurance Type</Label>
      <span className="text-danger">*</span>
      <select
        className="form-select"
        aria-label="Default select example"
        name="insurancetype_id"
        value={data.insurancetype_id}
        onChange={handleChange}
      >
        <option value="">Select Insurance Type</option>
        <option value={1}>General Insurance</option>
        <option value={2}>Life Insurance</option>
      </select>

      <Label className="mt-3">Company Name</Label>
      <span className="text-danger">*</span>
      <Input
        name="name"
        placeholder="Enter company name"
        value={data.name}
        onChange={handleChange}
      />

      <Label className="mt-3">Color code</Label>
      <span className="text-danger">*</span>
      <Input
        name="color_code"
        placeholder="eg. #ACDDDE"
        value={data.color_code}
        onChange={handleChange}
      />

      <Button
        type="submit"
        className="btn btn-dark mt-4"
        onClick={handleSubmit}
      >
        Submit
      </Button>
    </>
  )
}

export default CreateIns
